import { TermsOfUseFilterRequest } from '@/main/models/request';
import { TermsOfUseResponse } from '@/main/models/response';

import { fileImportApi } from '@/main/api';
import KOGBoxGrid from '@/main/components/shared/kogBoxGrid/kogBoxGrid';
import KOGPaginationGrid from '@/main/components/shared/paginationGrid/paginationGrid';
import * as StylesShared from '@/main/components/shared/styles';
import RowTermsOfUse from '@/main/screens/registration/termsOfUse/components/gridTermsOfUse/rowTermsOfUse';
import { isNullUndefined } from '@/main/services/reducerUtils';
import { getTranslateByKey } from '@/main/services/utils';
import { useCallback, useState } from 'react';
import * as S from './styles';
import { ResolutionsEnum } from '@/main/services/enum/ResolutionsEnum';

interface IGridTermsOfUse {
  filter: TermsOfUseFilterRequest | null;

  handleEdit: (fileImportGuid: string) => void;
}
export default function GridTermsOfUse({
  filter,
  handleEdit
}: Readonly<IGridTermsOfUse>) {
  const [dataGrid, setDataGrid] = useState<TermsOfUseResponse[]>([]);
  const rowHeaders = [
    <StylesShared.TextEllipsis key={0}>
      {getTranslateByKey('information.company')}
    </StylesShared.TextEllipsis>,
    <StylesShared.TextEllipsis key={1}>
      {getTranslateByKey('information.term')}
    </StylesShared.TextEllipsis>,
    <StylesShared.TextEllipsis key={2}>
      {getTranslateByKey('information.status')}
    </StylesShared.TextEllipsis>,
    <StylesShared.RowHeaderTextCenter key={3}>
      <StylesShared.TextEllipsis>
        {getTranslateByKey('information.actions')}
      </StylesShared.TextEllipsis>
    </StylesShared.RowHeaderTextCenter>
  ];

  const fetchData = useCallback(async (request: any) => {
    const response = await fileImportApi.searchGridTerm(request);
    return response.data;
  }, []);

  if (isNullUndefined(filter)) return;

  return (
    <S.Container>
      <KOGPaginationGrid
        showTitleResults
        dataGrid={dataGrid}
        formFilters={filter}
        setDataGrid={setDataGrid}
        fetchEqualFilters
        fetchMore={fetchData}>
        <KOGBoxGrid
          rowHeaders={rowHeaders}
          breakpointTable={ResolutionsEnum.desktop}
          sizeColumns={['25%', '10%', '7%', '5%']}>
          {dataGrid.map((item, index) => (
            <RowTermsOfUse
              key={item.fileImportGuid}
              term={item}
              index={index}
              handleEdit={handleEdit}
            />
          ))}
        </KOGBoxGrid>
      </KOGPaginationGrid>
    </S.Container>
  );
}
